module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0097.png.b577a4ae.jpg";